import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(private router: Router, public loader: LoadingBarService) { }
 

  async ngOnInit() {

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      console.log('here at naviagtion end about to scroll up');
      window.scrollTo(0, 0);
    });
  }
  isAdaAccessRoute(): boolean {
    return this.router.url.includes('/ada-access/auth-tools');
  }
  isDataProtectionRoute(): boolean {
    return this.router.url.includes('/data-protection/auth-tools');
  }
  isAssetManagementRoute(){
    return this.router.url.includes('/asset-management/auth-tools');
  }
  isDigitalIdentityRoute(){
    return this.router.url.includes('/digital-identity/auth-tools');
  }
}
